var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseButton,_vm._g(_vm._b({staticClass:"dxp-carousel-arrow-button",attrs:{"aria-label":_vm.direction,"data-list-slider-action":_vm.direction}},'base-button',_vm.$attrs,false),_vm.$listeners),[_c(_setup.Icon,{staticClass:"dxp-carousel-arrow-button__icon",attrs:{"name":_setup.arrow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }